import resolveConfig from "tailwindcss/resolveConfig"

import tailwindConfig from "../../../../../../../tailwind.config.mjs"

const resolvedConfig = resolveConfig(tailwindConfig)

/**
 * Build standard media query strings out of Tailwind config
 *
 * Takes an object like `{mobile: { max: "100px" }}` and turns it into something
 * compatible with standard media queries: `{mobile: "screen and (max-width:
 * 100px)"}
 *
 * @param {Object} screen Tailwind `screens` configuration object
 * @returns {Object}
 */
function buildMediaQueryStrings(screens) {
  const mapping = {}
  Object.keys(screens).forEach(key => {
    const output = ["screen"]
    const screen = screens[key]
    // This is naive and only handles max/min width for now
    Object.keys(screen).forEach(rule => {
      const value = screen[rule]
      output.push(`(${rule}-width: ${value})`)
    })
    mapping[key] = output.join(" and ")
  })
  return mapping
}

export const mediaQueries = buildMediaQueryStrings(resolvedConfig.theme.screens)
